interface ActiveVariation {
    id: number;
    name: string;
}

interface ConvertActiveExperienceEntry {
    variation: ActiveVariation;
}

interface ConvertHistoricalExperienceEntry {
    variation_id: number;
    variation_name: string;
}
export interface ConvertExperience {
    type: 'active' | 'historical';
    experimentId: number;
    variationId: number;
    variationName: string;
}

export class ConvertExperienceService {

    static getAllExperiences(): ConvertExperience[] {
        if (!window.convert) {
            return [];
        }
        const convert = window.convert;
        const active = (convert.currentData?.experiences || {}) as Record<number, ConvertActiveExperienceEntry>;
        const historical = (convert.historicalData?.experiences || {}) as Record<number, ConvertHistoricalExperienceEntry>;

        const result: ConvertExperience[] = [];

        Object.keys(active).forEach((experimentIdStr) => {
            const experimentId = Number(experimentIdStr);
            const entry = active[experimentId];
            if (!entry || !entry.variation) {
                return;
            }
            const variation = entry.variation;

            result.push({
                type: 'active',
                experimentId: experimentId,
                variationId: variation.id,
                variationName: variation.name,
            });
        });

        Object.keys(historical).forEach((experimentIdStr) => {
            const experimentId = Number(experimentIdStr);
            const entry = historical[experimentId];
            if (!entry) {
                return;
            }

            result.push({
                type: 'historical',
                experimentId: experimentId,
                variationId: entry.variation_id,
                variationName: entry.variation_name,
            });
        });

        return result;
    }
}
